(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jya-story"] && !Shopify.designMode) return;
  try {
    (function(){var raf;function build(row){var s=row.querySelector('.jya-s'),svg=s&&s.querySelector('svg');if(!svg)return;var w=s.clientWidth,h=s.clientHeight;if(!w||!h)return;var bx=+svg.getAttribute('data-bx'),y0=+svg.getAttribute('data-y0');var X=function(p){return (p*w/100).toFixed(1)},Y=function(p){return (p*h/100).toFixed(1)};var d;if(svg.getAttribute('data-end')){var f=row.querySelector('.jya-endfig'),ey=f?f.getBoundingClientRect().top-row.getBoundingClientRect().top+f.offsetHeight*0.1:h*0.3;var pr=row.previousElementSibling,ps=pr&&pr.querySelector('.jya-s'),sx=ps?ps.offsetLeft+ps.clientWidth/2:w/2,cx=w/2,m=ey/2;if(Math.abs(sx-cx)<1){d='M'+cx.toFixed(1)+' 0 L'+cx.toFixed(1)+' '+ey.toFixed(1)}else{d='M'+sx.toFixed(1)+' 0 C'+sx.toFixed(1)+' '+m.toFixed(1)+' '+cx.toFixed(1)+' '+m.toFixed(1)+' '+cx.toFixed(1)+' '+ey.toFixed(1)}var n=row.querySelector('.jya-endn');if(n){n.style.top=ey.toFixed(1)+'px';n.style.left=cx.toFixed(1)+'px'}}else{d='M'+X(50)+' '+Y(y0)+' C'+X(50)+' '+Y(30)+' '+X(bx)+' '+Y(30)+' '+X(bx)+' '+Y(50)+' S'+X(50)+' '+Y(72)+' '+X(50)+' '+h}svg.setAttribute('viewBox','0 0 '+w+' '+h);svg.querySelectorAll('path').forEach(function(p){p.setAttribute('d',d)})}function all(){document.querySelectorAll('.jya-story').forEach(function(st){st.querySelectorAll('.jya-r').forEach(build);st.classList.add('jya-ready')})}function sched(){cancelAnimationFrame(raf);raf=requestAnimationFrame(all)}sched();document.addEventListener('DOMContentLoaded',sched);window.addEventListener('load',sched);window.addEventListener('resize',sched);document.addEventListener('shopify:section:load',sched);if(window.ResizeObserver){new ResizeObserver(sched).observe(document.documentElement)}})();
  } catch(e) { console.error(e); }
})();
})();
